/*
 * @Author: zhouwei
 * @Date: 2019-11-07 10:11:37
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-05-17 23:20:19
 * @Desc: 基础数据模块，营销资料和营销计划共用
*/
<template>
  <div class="base">
    <div class="tab">
      <div
        v-for="(item,index) in myBaseData"
        :key="index"
        class="tab-item"
      >
        <span class="number">
          {{ item.value }}
        </span>
        <span class="text">
          {{ baseDataObj[item.key] }}
        </span>
      </div>
    </div>
    <div class="visit">
      <div
        class="visit-static"
        :style="{
          width: needSaleStatistics ? '70%' : '100%'
        }"
      >
        <div class="header">
          <div class="header-content">
            <i></i>
            <span>访问统计</span>
          </div>
          <mk-radio-group
            v-model="timeUnit"
            size="small"
            @change="change"
          >
            <mk-radio-button label="月"></mk-radio-button>
            <mk-radio-button label="周"></mk-radio-button>
            <mk-radio-button label="日"></mk-radio-button>
          </mk-radio-group>
        </div>
        <div class="chart">
          <div
            v-if="chartData && chartData.length > 0"
            class="chart-data"
          >
            <div class="line"></div>
            <mk-stacked
              :data="chartData"
              :options="chartOptions"
            >
            </mk-stacked>
          </div>
          <no-data v-else />
        </div>
      </div>
      <member-statistics
        v-if="needSaleStatistics"
        :base-data="baseData"
      />
    </div>
  </div>
</template>
<script>
import noData from '@components/no-data'
import memberStatistics from './member-statistics'
export default {
  components: {
    noData,
    memberStatistics
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    chartData: {
      type: Array,
      defalut () {
        return []
      }
    },
    // eslint-disable-next-line vue/require-default-prop
    chartOptions: {
      type: Object,
      defalut () {
        return {}
      }
    },
    baseData: {
      type: Object,
      default () {
        return {}
      }
    },
    needSaleStatistics: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      chartData2: [
        {
          item:
            '这里是示例这里是示例这里是示例这里是示例这里是示例这里是示例这里是示例这里是示例',
          attachCoun: 10
        }
      ],
      chartOptions2: {
        chart: {
          height: 400,
          padding: [50, 50, 50, 50],
          scale: {
            time: {
              tickCount: 12 // 显示<=12的所有数据
            }
          }
        },
        axis: [
          {
            name: 'time'
          },
          {
            name: 'attachCount'
          }
        ],
        geom: [
          {
            type: 'point',
            position: 'time*attachCount', // 对于数据的year,value
            color: 'type' // 对于数据的city
          },
          {
            type: 'line',
            position: 'time*attachCount',
            color: 'type'
          }
        ]
      },
      baseDataObj: {
        visits: '累计浏览量（PV）',
        visitors: '累计浏览人数（UV）',
        coverWxFriend: '覆盖微信好友人数',
        addClue: '新增线索数',
        forward: '用户转发数',
        saleShare: '员工分享数'
      },
      timeUnit: '日',
      member: ''
    }
  },
  computed: {
    myBaseData () {
      let arr = []
      let index = 0
      for (let s in this.baseData) {
        arr[index] = {
          key: s,
          value: this.baseData[s]
        }
        index++
      }
      return arr
    }
  },
  methods: {
    change (e) {
      this.$emit('dateChange', e)
    }
  }
}
</script>
<style lang="scss" scoped>
.base {
  .tips {
    display: inline-flex;
    font-size: 14px;
    line-height: 14px;
    padding-top: 20px;
  }

  .tab {
    display: flex;
    margin-top: 20px;

    .tab-item {
      flex: 1;
      display: flex;
      height: 100px;
      margin-right: 32px;
      background: #f8f8f8;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      cursor: pointer;

      .number {
        font-size: 18px;
        color: #009cff;
      }

      .text {
        font-size: 13px;
        color: #262626;
        margin-top: 12px;
      }
    }

    .tab-item:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .visit {
    // width: 960px;
    width: 100%;
    display: flex;
    margin-top: 24px;

    .visit-static {
      flex: 1;

      .header {
        // height: 60px;
        border-bottom: 1px solid #d9d9d9;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 12px;

        .header-content {
          display: flex;
        }

        i {
          display: block;
          width: 4px;
          height: 16px;
          background-color: #009cff;
          border-radius: 1px;
          margin-right: 8px;
        }

        span {
          font-size: 14px;
          color: #262626;
          font-weight: 500;
        }
      }

      .no-data {
        display: flex;
        flex-direction: column;
        align-items: center;
        // padding-bottom: 100px;
        padding: 50px 0;

        .no-data-img {
          width: 80px;
          height: 59px;

          .img {
            width: 100%;
            height: 100%;
          }
        }

        .no-data-txt {
          font-size: 14px;
          margin-top: 12px;
          color: #bfbfbf;
        }
      }
    }

    .member-statistics {
      width: 30%;
      // min-width: 380px;
      flex-shrink: 0;
      margin-left: 20px;
    }
  }
}
</style>
